// extracted by mini-css-extract-plugin
export default {"landing_page":"LandingPage_landing_page__AgjIk","logo":"LandingPage_logo__Q0JtU"};